import { render, staticRenderFns } from "./WelcomeBonus.vue?vue&type=template&id=aa9868a2&"
import script from "./WelcomeBonus.vue?vue&type=script&lang=ts&setup=true&"
export * from "./WelcomeBonus.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa9868a2')) {
      api.createRecord('aa9868a2', component.options)
    } else {
      api.reload('aa9868a2', component.options)
    }
    module.hot.accept("./WelcomeBonus.vue?vue&type=template&id=aa9868a2&", function () {
      api.rerender('aa9868a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramInfo/components/WelcomeBonus.vue"
export default component.exports